import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

export const CANCEL_BOOKING: DocumentNode = gql`
  mutation CancelBooking($bookingId: String!, $rebooking: Boolean, $refundMethod: String) {
    cancelBooking(bookingId: $bookingId, rebooking: $rebooking, refundMethod: $refundMethod) {
      success
      message
    }
  }
`;

export const GET_BOOKING_DATA: DocumentNode = gql`
  query Booking($bookingId: String!, $refundMethod: String) {
    booking(bookingId: $bookingId) {
      id
      saleId
      offerId
      rooms
      bookingDates {
        start
        end
      }
      occupancy {
        adults
      }
      cancellationSummary(refundMethod: $refundMethod) {
        paidBreakdown {
          total {
            forDisplay
          }
          items {
            concept
            price {
              forDisplay
            }
          }
        }
        toBeRefundedBreakdown {
          total {
            forDisplay
          }
          items {
            concept
            price {
              forDisplay
            }
          }
        }
        alternativeRefundMethods {
          enticementText
          enticementCTA
        }
        editorial {
          header
          summary
          refundSummary
          mainCTA
          disclaimer
          refundTotalDescription
        }
      }
    }
  }
`;
